var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"history-detail"},[_c('el-row',[_c('el-col',[_c('h2',[_vm._v("購入・ポイント履歴 詳細")])])],1),_c('el-row',[_c('el-col',[_c('OrderData',{attrs:{"orderId":_vm.orderId}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }